<template>
  <BaseDialog
    v-model="openOrderPodListDialog"
    :actionAllow="false"
    title="Document List"
    cardTextClass="pa-0 ma-0"
    width="60vw"
    @reset="$emit('refreshList')"
  >
    <template #information>
      <v-form
        v-model="isValid"
        ref="documentForm"
        class="content_background pa-5"
      >
        <v-row class="pt-3 pb-5" v-if="permissions && permissions.add">
          <v-col cols="4">
            <SelectField
              id="attachment_type"
              name="attachment_type"
              :itemsList="
                orderType == 'delivery'
                  ? attachmentDeliveryType
                  : attachmentPickupType
              "
              hide-details="auto"
              itemText="label"
              itemValue="value"
              dense
              readonly
              v-model="attachment_type"
              label=" Attachment Type*"
              outlined
              :rules="[(v) => !!v || 'Attachment Type is required']"
              required
            >
            </SelectField>
          </v-col>
          <v-col cols="3">
            <FileField
              id="attachment"
              name="attachment"
              accept="image/jpeg, image/png, application/pdf"
              hide-details="auto"
              outlined
              dense
              v-model="fileToUpload"
              label="Select Attachment"
              prepend-icon=""
              prepend-inner-icon="mdi-attachment"
              :error-messages="formErrors.document"
              @input="delete formErrors.document"
            ></FileField>
          </v-col>
          <v-col cols="3">
            <InputField
              id="description"
              name="description"
              hide-details="auto"
              outlined
              dense
              v-model="description"
              label="Description"
            />
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <PrimaryButton
              id="ordersPodUpload"
              color="primary"
              depressed
              name="Upload"
              :disabled="!fileToUpload || !attachment_type"
              @click="uploadAttachement"
            >
            </PrimaryButton>
          </v-col>
        </v-row>

        <v-row class="ma-0">
          <v-col cols="12" class="app-relative pa-0 ma-0">
            <v-btn-toggle
              dense
              v-model="toggleView"
              mandator
              class="pa-1 position-absolute"
            >
              <v-btn class="primary">
                <v-icon color="white">mdi-image</v-icon>
              </v-btn>
              <v-btn class="primary">
                <v-icon color="white">mdi-table</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="12" class="pa-0" v-if="toggleView == 0">
            <ListLayout
              :gridStyle="{ height: '400px', 'overflow-y': 'auto' }"
              :context="context"
              title="Document List"
              :hasAfterTitle="false"
              :hasFilter="false"
              :isColumnShowVisibility="false"
              :tableData="tableData"
              :total="totalItems"
              :tableHeader="tableHeader"
            >
            </ListLayout>
          </v-col>
          <v-col cols="12" v-else class="mt-5 pt-16">
            <v-row v-if="tableData.length > 0">
              <v-col cols="3" v-for="(item, i) in tableData" :key="i">
                <v-card elevation="0" outlined class="pa-2 app-relative">
                  <v-card-title
                    class="pa-2 w-100 white"
                    style="position: absolute; top: 0; right: 0; z-index: 1"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span class="text-caption" v-bind="attrs" v-on="on">{{
                          item.document_type
                        }}</span>
                      </template>
                      <span class="text-capitalize">Document Type </span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template #activator="{ on, attrs }">
                        <v-icon
                          color="error"
                          v-on="on"
                          v-bind="attrs"
                          @click="deletePOD(item.id)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </v-card-title>
                  <a :href="item.attachment" target="_blank">
                    <v-img
                      :src="item.attachment"
                      height="150px"
                      width="300px"
                    />
                  </a>
                  <v-card-title
                    class="py-2 w-100 white"
                    style="
                      position: absolute;
                      bottom: 0;
                      right: 0;
                      z-index: 1;
                      opacity: 0.8;
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          class="text-caption text-center w-100"
                          v-bind="attrs"
                          v-on="on"
                          >{{ item.added_by }}</span
                        >
                      </template>
                      <span class="text-capitalize">added by </span>
                    </v-tooltip>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
            <div
              v-else
              style="height: 140px"
              class="d-flex align-center justify-center white"
            >
              <h6 class="text-grey">There is no document available.</h6>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import OrderAttachmentButton from "@/components/Button/OrderAttachmentButton.vue";
import { bus } from "@/main";

export default {
  props: {
    value: Boolean,
    orderID: Number,
    orderType: {
      type: String,
      default: "delivery",
    },
  },
  components: { BaseDialog, ListLayout, OrderAttachmentButton },

  data() {
    return {
      tableHeader: [
        {
          headerName: "Added by",
          field: "added_by",
          sortable: false,
          resizable: false,
        },
        {
          headerName: "description",
          field: "description",
          sortable: false,
          resizable: false,
        },
        {
          headerName: "Actions",
          field: "actions",
          sortable: false,
          resizable: false,
          cellRenderer: "OrderAttachmentButton",
        },
      ],
      toggleView: 0,
      attachmentDeliveryType: [
        { label: "Proof of delivery", value: "pod" },
        { label: "Order", value: "order" },
        { label: "Others", value: "others" },
      ],
      attachmentPickupType: [
        { label: "Proof of Pickup", value: "pod" },
        { label: "Order", value: "order" },
        { label: "Others", value: "others" },
      ],
      isValid: false,
      tableData: [],
      documentForm: {},
      showForm: false,
      fileToUpload: null,
      description: null,
      attachment_type: "pod",
      permissions: null,
      formErrors: [],
      totalItems: 0,
    };
  },
  watch: {
    openOrderPodListDialog(val) {
      if (val) {
        this.getOrderDocumentsList();
      }
    },
    showForm(val) {
      if (!val) {
        this.resetForm();
      }
    },
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    openOrderPodListDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    deletePOD(id) {
      this.$root
        .$confirm("Delete?", "Are you sure want to delete?", {
          color: "error",
        })
        .then(async (confirm) => {
          if (confirm) {
            this.$api.order
              .deleteOrderDocument(id)
              .then(() => {
                bus.$emit("showToastMessage", {
                  message: "Attachment Deleted Successfully!",
                  color: "Error",
                });
                this.getOrderDocumentsList();
              })
              .catch((err) => {
                console.error(err);
              });
          }
        });
    },
    closeDialog() {
      this.openOrderPodListDialog = false;
      this.attachment_type = "pod";
      this.resetForm();
    },
    resetForm() {
      if (this.$refs.documentForm) {
        this.$refs.documentForm.reset();
        setTimeout(() => {
          this.attachment_type = "pod";
        }, 1000);
      }
    },
    download(url, name, type = null) {
      if (type) {
        name = name.slice(name.lastIndexOf("/") + 1, name.length);
      }
      this.$axios({
        url: url,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
      });
    },
    getOrderDocumentsList() {
      bus.$emit("showLoader", true);
      this.$api.order
        .getUploadOrderAttachment({ limit: "all", order: this.orderID })
        .then((res) => {
          this.tableData = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    uploadAttachement() {
      let formData = new FormData();
      if (this.description) {
        formData.append("description", this.description);
      }
      formData.append("attachment_type", this.attachment_type);
      formData.append("attachment", this.fileToUpload);
      formData.append("order", this.orderID);
      bus.$emit("showLoader", true);
      this.$api.order
        .uploadOrderAttachment(formData)
        .then((res) => {
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "Attachment Uploaded Successfully!",
            color: "success",
          });
          this.showForm = false;
          this.fileToUpload = null;
          this.description = null;
          this.getOrderDocumentsList();
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "can not Uploaded Successfully!",
            color: "error",
          });
        });
    },
  },
  created() {
    this.permissions = this.$permissions.getPermission("order");
  },
};
</script>
<style scoped lang="scss">
.position-absolute {
  position: absolute;
  right: 30px;
  top: 30px;
  z-index: 1;
}
</style>
